import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faTable, faTachometer, faTasks, faEye, faPencil, faTrashCan, faVideo, faArrowLeft, faDumbbell, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';

import { getSessionTemplateDetailAPI } from "../../../API/SessionTemplate";
import { putSessionTemplateUpdateAPI } from "../../../API/SessionTemplate";
import useLocalStorage from "../../../Hooks/useLocalStorage";
import FormInputField from "../../Reusable/FormInputField";
import PageLoadingContent from "../../Reusable/PageLoadingContent";
import { topAlertMessageState, topAlertStatusState } from "../../../AppState";
import SessionTemplateVideoSectionExerciseListDesktop from "./DetailForExerciseListDesktop";
import SessionTemplateVideoSectionExerciseListMobile from "./DetailForExerciseListMobile";


function SessionTemplateVideoSectionExerciseDetailForExerciseList() {
    ////
    //// URL parameters.
    ////

    const { id, vsIndex } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useLocalStorage(id, "");
    const [selectedExerciseForDeletion, setSelectedExerciseForDeletion] = useState("");
    const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] = useState(false);
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    function onExerciseDeleteSuccess(response){
        console.log("onExerciseDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Exercise deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Fetch again an updated list.
        getSessionTemplateDetailAPI(
            id,
            onSessionTemplateDetailSuccess,
            onSessionTemplateDetailError,
            onSessionTemplateDetailDone
        );
    }

    function onExerciseDeleteError(apiErr) {
        console.log("onExerciseDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onExerciseDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onExerciseDeleteDone() {
        console.log("onExerciseDeleteDone: Starting...");
        setFetching(false);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("SessionTemplate updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSelectExerciseForDeletion = (e, exercise) => {
        console.log("onSelectExerciseForDeletion", exercise);
        setSelectedExerciseForDeletion(exercise);
    }

    const onDeselectExerciseForDeletion = (e) => {
        console.log("onDeselectExerciseForDeletion");
        setSelectedExerciseForDeletion("");
    }

    const onDeleteConfirmButtonClick = (e) => {
        console.log("onDeleteConfirmButtonClick"); // For debugging purposes only.
        console.log("selectedExerciseForDeletion:", selectedExerciseForDeletion);

        //
        // The following code will remove the data from the JSON.
        //

        let eIndex;
        let videoSection = sessionTemplate.videoSections[vsIndex];
        for (let exerciseIndex in videoSection.exercises) {
            let ex = videoSection.exercises[exerciseIndex];
            if (ex.name === selectedExerciseForDeletion.name) {
                console.log(ex);
                eIndex = exerciseIndex;
                break;
            }
        }

        console.log("videoSectionIndex:", eIndex);
        videoSection.exercises.splice(eIndex, 1);

        // Remove from state.
        setSelectedExerciseForDeletion("");

        // Update the sessionTemplate.
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    // Defensive code: The following code will extract the video section from the sessionTemplate, else return null.
    let videoSection, name, detail, exercises = null;
    if (sessionTemplate !== undefined && sessionTemplate !== null && sessionTemplate !== "") {
        videoSection = sessionTemplate.videoSections[vsIndex];
        if (videoSection !== undefined && videoSection !== null && videoSection !== "") {
            name = videoSection.name;
            detail = videoSection.detail;
            exercises = videoSection.exercises;
        }
    }
    console.log(name, detail, exercises); // For debugging purposes only.

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Video Sections)</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section (Exercises)</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-template/${id}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Details (Video Sections)</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    <nav class="">
                        <div class={`modal ${selectedExerciseForDeletion ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={onDeselectExerciseForDeletion}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this <b>exercise</b> and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={onDeselectExerciseForDeletion}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>
                    <nav class="box">

                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</p>
                            </div>
                            <div class="column has-text-right">
                                <Link to={`/session-template/${id}/video-section/${vsIndex}/exercises/add`} class="button is-success is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPlus} />&nbsp;New Exercise
                                </Link>
                            </div>
                        </div>

                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link class="is-active" to={`/session-template/${id}/video-section/${vsIndex}`}>Detail</Link>
                                </li>
                                <li>
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}/exercises`}><strong>Exercises</strong></Link>
                                </li>
                            </ul>
                        </div>

                        {/* Subtitle */}
                        <h1 class="title is-6"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercises</h1>

                        {isFetching && <PageLoadingContent displayMessage={"Please wait"} />}

                        {exercises && exercises.length > 0
                            ?
                            <div class="container">
                                {/*
                                    ##################################################################
                                    EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP SCREEN.
                                    ##################################################################
                                */}
                                <div class="is-hidden-touch mb-5">
                                    <SessionTemplateVideoSectionExerciseListDesktop
                                        id={id}
                                        vsIndex={vsIndex}
                                        exercises={exercises}
                                        onSelectExerciseForDeletion={onSelectExerciseForDeletion}
                                    />
                                </div>

                                {/*
                                    ###########################################################################
                                    EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR MOBILE SCREEN.
                                    ###########################################################################
                                */}
                                <div class="is-fullwidth is-hidden-desktop mb-5">
                                    <SessionTemplateVideoSectionExerciseListMobile
                                        id={id}
                                        vsIndex={vsIndex}
                                        exercises={exercises}
                                        onSelectExerciseForDeletion={onSelectExerciseForDeletion}
                                    />
                                </div>

                            </div>
                            :
                            <div class="hero-body">
                                  <p class="title">
                                      <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No data
                                  </p>
                                  <p class="subtitle">
                                      No data. <b><Link to={`/session-template/${id}/video-section/${vsIndex}/exercises/add`}>Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started adding your first exercise.
                                  </p>
                            </div>
                        }

                        <div class="columns">
                            <div class="column is-half">
                                <Link to={`/session-template/${id}/video-sections`} class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Video Sections</Link>
                            </div>
                            <div class="column is-half has-text-right">
                                <Link to={`/session-template/${id}/video-section/${vsIndex}/exercises/add`} class="button is-success is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;Add Exercise</Link>
                            </div>
                        </div>
                    </nav>
                </section>
            </div>
        </>
    );
}


export default SessionTemplateVideoSectionExerciseDetailForExerciseList;
